import Inventory2RoundedIcon from "@mui/icons-material/Inventory2Rounded";
import { Box, Grid, Stack, Typography } from "@mui/material";
import { colors } from "@components/ui/colors";
import { SECTION_STYLES } from "@components/jobs/jobs-list/jobs-layout/components/Summary/JobScopeOfWorkView";
import { CARD_STYLES } from "./ScopeOfWorkTypeOfService";

export const ScopeOfWorkAdditionalObjects = ({ list = [] }) => {
  if (!list.length) return null;

  return (
    <Box sx={SECTION_STYLES.root}>
      <SectionHeader title="Additional objects" count={list.length} icon={<Inventory2RoundedIcon sx={{ fontSize: 20 }} />} />

      <Grid container spacing={1.5}>
        {list.map((item) => {
          const obj = item.additionalObject ?? item.object ?? item;
          const objectName = obj.name ?? obj.uid ?? "Unnamed object";
          const imageUrl = obj.imageUrl ?? obj.image?.url ?? obj.iconUrl ?? null;

          return (
            <Grid item xs={12} sm={6} md={4} lg={3} key={obj.uid ?? item.uid ?? objectName}>
              <Box sx={SECTION_STYLES.imageCard}>
                <Box sx={SECTION_STYLES.imageBox}>
                  {imageUrl ? (
                    <Box
                      component="img"
                      src={imageUrl}
                      alt={objectName}
                      sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    <Inventory2RoundedIcon sx={{ fontSize: 34 }} />
                  )}
                </Box>

                <Box sx={{ mt: 1.25, minWidth: 0 }}>
                  <Typography
                    sx={{
                      fontSize: "0.9rem",
                      fontWeight: 900,
                      color: colors.gray[800],
                      lineHeight: 1.25,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    title={objectName}
                  >
                    {objectName}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

function SectionHeader({ title, count, icon }: { title: string; count: number; icon: React.ReactNode }) {
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} sx={{ mb: 1.5 }}>
      <Stack direction="row" alignItems="center" spacing={1.25}>
        <Box sx={SECTION_STYLES.iconBox}>{icon}</Box>

        <Box>
          <Typography sx={CARD_STYLES.sectionLabel}>{title}</Typography>
        </Box>
      </Stack>

      <Box sx={SECTION_STYLES.pill}>{count} selected</Box>
    </Stack>
  );
}
